import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getCargos, getResponsables, newResponsable, } from "../../../../redux/actions/empleador";
import { postCabecera } from "../../../../redux/actions/resolucion";
import CircularLoading from "../../../commons/loading/CircularLoading";
import NewResponsableDialog from "../../../commons/responsables/dialog/NewResponsableDialog";
import ResponsablesEnum from "../../../enums/responsablesEnum";
import { StyledResolucion } from "../../../styled/Prevencion";
import CabeceraForm from "./CabeceraForm";

const initialValues = {
  cantidadTrabajadoresProduccion: 0,
  cantidadTrabajadoresEventualesProduccion: 0,
  cantidadTrabajadoresAdministracion: 0,
  cantidadTrabajadoresEventualesAdministracion: 0,
  sePuedeFumar: false,
  espacioParaFumar: false,
  responsableEmpresa: "",
  responsableMedicina: "",
  responsableSH: "",
  contacto: "",
};

const CabeceraContainer = ({
  nextForm,
  handleCancelResolucion,
  establecimiento,
}) => {
  const dispatch = useDispatch();
  const responsables = useSelector((state) => state.empleador.responsables.data);
  const cabeceraRedux = useSelector(
    (state) => state.resolucion.postResolucion.cabecera
  );
  const datosEstablecimiento = useSelector(
    (state) => state.resolucion.datosEstablecimiento
  );

  const [openDialogResponsables, setOpenDialogResponsables] = useState(false);

  const [formModel, setFormModel] = useState(null);
  const [respState, setResp] = useState("ResponsableSH");
  const [responsableType, setResponsableType] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  // En caso de que el form tenga valores necesitamos que los responsables ya esten cargados, pero no podemos usar el loading de responsables ya que dejaria cargando el form cada vez que se agrega un responsable
  useEffect(() => {
    const responsablePromises = Object.values(ResponsablesEnum).map(enumValue =>
      dispatch(getResponsables(enumValue))
    );
    Promise.all(responsablePromises).finally(() => {
      setInitialLoading(false);
    });
  }, [])


  useEffect(() => {
    if (establecimiento != null) {
      setFormModel(() => ({
        ...initialValues,
        cantidadTrabajadoresProduccion:
          cabeceraRedux?.cantidadTrabajadoresProduccion ||
          initialValues.cantidadTrabajadoresProduccion,
        cantidadTrabajadoresAdministracion:
          cabeceraRedux?.cantidadTrabajadoresAdministracion ||
          initialValues.cantidadTrabajadoresAdministracion,
        cantidadTrabajadoresEventualesAdministracion:
          cabeceraRedux?.cantidadTrabajadoresEventualesAdministracion ||
          initialValues.cantidadTrabajadoresEventualesAdministracion,
        cantidadTrabajadoresEventualesProduccion:
          cabeceraRedux?.cantidadTrabajadoresEventualesProduccion ||
          initialValues.cantidadTrabajadoresEventualesProduccion,
        sePuedeFumar: cabeceraRedux?.sePuedeFumar || initialValues.sePuedeFumar,
        espacioParaFumar:
          cabeceraRedux?.espacioParaFumar || initialValues.espacioParaFumar,
        responsableEmpresa:
          cabeceraRedux?.responsableEmpresa || initialValues.responsableEmpresa,
        responsableMedicina:
          cabeceraRedux?.responsableMedicina ||
          initialValues.responsableMedicina,
        responsableSH:
          cabeceraRedux?.responsableSH || initialValues.responsableSH,
        contacto: cabeceraRedux?.contacto || initialValues.contacto,
        idEstablecimientoDeclaradoSRT: cabeceraRedux?.idEstablecimientoDeclaradoSRT,
      }));
    }
  }, [establecimiento]);

  const handleSubmit = (values) => {
    dispatch(postCabecera(values));
    nextForm("Observaciones");
  };

  const handleOpenDialog = (resp, cu) => {
    setResp(resp);
    setResponsableType(cu);
    dispatch(getCargos(cu));
    setOpenDialogResponsables(true);


  };

  const handleCloseResponsableDialog = () => {
    setOpenDialogResponsables(false);
  };

  const handleAddResponsable = (values) => {
    dispatch(newResponsable(values)).then((resp) => {
      dispatch(getResponsables(responsableType)).then((res) => {
        debugger;
        let objAux = {
          id: res.value.data[res.value.data.length - 1].id,
          nombre: res.value.data[res.value.data.length - 1].nombre,
        };
        if (respState == "responsableEmpresa") {
          setFormModel({
            ...formModel,
            responsableEmpresa: objAux.id,
          });
        } else if (respState == "responsableMedicina") {
          setFormModel({
            ...formModel,
            responsableMedicina: objAux.id,
          });
        } else if (respState == "responsableSH") {
          setFormModel({
            ...formModel,
            responsableSH: objAux.id,
          });
        } else if (respState == "contacto") {
          setFormModel({
            ...formModel,
            contacto: objAux.id,
          });
        }
        setOpenDialogResponsables(false);
        toast.success("Responsable agregado correctamente");
      });
    });
  };

  return (
    <StyledResolucion.FormsContainer>
      {
        initialLoading ?
          (<CircularLoading />)
          : (
            <>
              <CabeceraForm
                handleSubmit={handleSubmit}
                handleCancelForm={handleCancelResolucion}
                handleOpenDialog={handleOpenDialog}
                formModel={formModel}
                establecimiento={establecimiento}
              />
              <NewResponsableDialog
                open={openDialogResponsables}
                handleSubmit={handleAddResponsable}
                handleClose={handleCloseResponsableDialog}
              />
            </>

          )
      }

    </StyledResolucion.FormsContainer>
  );
};

export default CabeceraContainer;
